import React, { useState, useCallback, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useFirestore } from '../../hooks/useFirestore';
import { getAboutInfo } from '../../firebase/firestore';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Button from '../../components/common/Button';
import Loading from '../../components/common/Loading';
import './ManageAbout.css';

const ManageAbout = () => {
    const { data: aboutInfo, loading, refresh } = useFirestore(useCallback(() => getAboutInfo(), []));
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        titleAr: '',
        titleEn: '',
        descAr: '',
        descEn: '',
        mission: { ar: '', en: '' },
        vision: { ar: '', en: '' }
    });

    useEffect(() => {
        if (aboutInfo) {
            setFormData({
                titleAr: aboutInfo.titleAr || '',
                titleEn: aboutInfo.titleEn || '',
                descAr: aboutInfo.descAr || '',
                descEn: aboutInfo.descEn || '',
                mission: aboutInfo.mission || { ar: '', en: '' },
                vision: aboutInfo.vision || { ar: '', en: '' }
            });
        }
    }, [aboutInfo]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await updateDoc(doc(db, 'about', 'company'), formData);
            alert('تم حديث بيانات "من نحن" بنجاح');
            refresh();
        } catch (error) {
            console.error('Error updating about info:', error);
            alert('فشل تحديث البيانات.');
        } finally {
            setSubmitting(false);
        }
    };

    if (loading && !aboutInfo) return <Loading />;

    return (
        <div className="manage-about">
            <h1 className="admin-page-title">إدارة محتوى "من نحن"</h1>

            <form onSubmit={handleSubmit} className="admin-form-container shadow-premium">
                <section className="form-section">
                    <h3>المقدمة والقصة</h3>
                    <div className="form-row">
                        <div className="form-group">
                            <label>العنوان بالعربية</label>
                            <input
                                type="text"
                                value={formData.titleAr}
                                onChange={(e) => setFormData({ ...formData, titleAr: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label>Title (English)</label>
                            <input
                                type="text"
                                value={formData.titleEn}
                                onChange={(e) => setFormData({ ...formData, titleEn: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>الوصف بالعربية</label>
                        <textarea
                            rows="5"
                            value={formData.descAr}
                            onChange={(e) => setFormData({ ...formData, descAr: e.target.value })}
                        ></textarea>
                    </div>
                    <div className="form-group">
                        <label>Description (English)</label>
                        <textarea
                            rows="5"
                            value={formData.descEn}
                            onChange={(e) => setFormData({ ...formData, descEn: e.target.value })}
                        ></textarea>
                    </div>
                </section>

                <section className="form-section">
                    <h3>الرسالة (Mission)</h3>
                    <div className="form-group">
                        <label>الرسالة بالعربية</label>
                        <textarea
                            rows="3"
                            value={formData.mission.ar}
                            onChange={(e) => setFormData({
                                ...formData,
                                mission: { ...formData.mission, ar: e.target.value }
                            })}
                        ></textarea>
                    </div>
                    <div className="form-group">
                        <label>Mission (English)</label>
                        <textarea
                            rows="3"
                            value={formData.mission.en}
                            onChange={(e) => setFormData({
                                ...formData,
                                mission: { ...formData.mission, en: e.target.value }
                            })}
                        ></textarea>
                    </div>
                </section>

                <section className="form-section">
                    <h3>الرؤية (Vision)</h3>
                    <div className="form-group">
                        <label>الرؤية بالعربية</label>
                        <textarea
                            rows="3"
                            value={formData.vision.ar}
                            onChange={(e) => setFormData({
                                ...formData,
                                vision: { ...formData.vision, ar: e.target.value }
                            })}
                        ></textarea>
                    </div>
                    <div className="form-group">
                        <label>Vision (English)</label>
                        <textarea
                            rows="3"
                            value={formData.vision.en}
                            onChange={(e) => setFormData({
                                ...formData,
                                vision: { ...formData.vision, en: e.target.value }
                            })}
                        ></textarea>
                    </div>
                </section>

                <div className="form-actions">
                    <Button type="submit" variant="primary" disabled={submitting}>
                        {submitting ? 'جاري الحفظ...' : 'حفظ التغييرات'}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default ManageAbout;
